export const RETRIEVE_WITH_PROJECT_ID_PENDING =
  'RETRIEVE_WITH_PROJECT_ID_PENDING';
export const RETRIEVE_WITH_PROJECT_ID_SUCCESS =
  'RETRIEVE_WITH_PROJECT_ID_SUCCESS';
export const RETRIEVE_WITH_PROJECT_ID_FAILURE =
  'RETRIEVE_WITH_PROJECT_ID_FAILURE';
